import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Api from "../../services/Api";
import {getLanguage} from "../../lang/helpers";
import {useNavigate, useParams} from "react-router";
import Loading from "../../components/Loading";
import LocalBreadcrumbs from "../../components/Breadcrumbs/LocalBreadcrumbs";


interface CustomerSurveyQuestionInterface {
  id: string;
  name: string;
  grade: number;
}

interface CustomerSurveyCategoryInterface {
  id: string;
  name: string;
  grade: number;
  questions: Array<CustomerSurveyQuestionInterface>
}

interface CustomerSurveyInterface {
  id: string;
  name: string;
  created: string;
  categories: Array<CustomerSurveyCategoryInterface>
}

const CustomerSurveyReport = () => {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(); // i18n translation hook
  const lang = getLanguage(i18n.language);
  const [loaded, setLoaded] = useState(false);
  const [customerSurvey, setCustomerSurvey] = useState<CustomerSurveyInterface|null>(null);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    getData();
  }, []);


  const getData = () => {
    api.get("client/assessments/customer_survey_report/" + id).then(response => {
      setCustomerSurvey(response.json.survey);
      setLoaded(true);
    })
  }

  if (!loaded) {
    return <Loading />;
  }

  if (!customerSurvey) {
    return <div className="mt-4">Error loading survey</div>
  }

  const crumbs = [
    {name: t("assessments"), url: "/assessments"},
    {name: customerSurvey.name + " " + customerSurvey.created.substring(0, 10)},
  ]

  return (
    <div className="main-one-col small">
      <LocalBreadcrumbs crumbs={crumbs}/>
      <div className="z-h2 mt-4">{customerSurvey.name} {customerSurvey.created.substring(0, 10)}</div>
      {
        customerSurvey.categories.map(category => (
          <div className="mt-6" key={category.id}>
            <div className="mt-1 flex justify-between items-center border-b border-b-indigo-700">
              <div className="z-title1">{category.name}</div>
              <div className="z-title1">{category.grade.toFixed(1)}</div>
            </div>

            {
              category.questions.map(question => (
                <div key={question.id}
                     className="mt-1 flex justify-between items-center border-b border-b-indigo-700 gap-x-8">
                  <div className="z-body1">{question.name}</div>
                  <div className="z-title2">{question.grade.toFixed(1)}</div>
                </div>
              ))
            }
          </div>

        ))
      }
    </div>
  );
}

export default CustomerSurveyReport;